export const differenceBy = <T extends Record<string, unknown>, K extends Record<string, unknown>>(initialArray: T[], arrayToExclude: K[], key: string) => {
    return initialArray.filter(initialItem => !arrayToExclude.some(itemToExclude => itemToExclude[key] === initialItem[key]));
};
